export enum ELocalStorage {
  TOKEN = '@core_base/token',
  APP_CONFIG = '@core_base/AppConfig',
}
